module.exports = __webpack_public_path__ + "img/金榜志愿通系统.06520585.png";